import './App.css';
import './index.css';
import Me from './component/me';

function App() {
  return <Me />;
}

export default App;
